import React, { useEffect, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom';
import { useStaticDataStore } from '../../stores/staticData';
import dummyFounder from '../../assets/images/dummyFounder.png'
import { suspendUserApi, founderListApi } from '../../api/usersApi';

const ProfileTab = ({ profileData, setEdit, setShowNotification, setNotificationMessage, handleActionUser, isSuspendLoading, setSelectUser, setPersonalEmail, personalEmail, handleUpdateUser, isSaveLoading, setIsSaveLoading, registedEmail, setRegistedEmail, setReason, reason, LazyImage, isEditUser, handleRestore }) => {
    const { data: staticData } = useStaticDataStore();
    let university = [];
    if (staticData?.university?.length) {
        university = staticData?.university;
    }
    let startupRole = [];
    if (staticData?.startupRole?.length) {
        startupRole = staticData?.startupRole;
    }
    let industryTags = [];
    if (staticData?.industryTags?.length) {
        industryTags = staticData?.industryTags;
    }
    let startupStages = [];
    if (staticData?.startupStages?.length) {
        startupStages = staticData?.startupStages;
    }

    const [errorMessage, setErrorMessage] = useState('');
    const [emailErrorMessage, setEmailErrorMessage] = useState('');
    const [registerEmailErrorMessage, setRegisterEmailErrorMessage] = useState('');
    const [changedReason, setChangedReason] = useState('');
    const [changedPersonalEmail, setChangePersonalEmail] = useState('')
    const [changedRegisterEmail, setChangeRegisterEmail] = useState('')

    useEffect(() => {
        if (isEditUser) {
            setChangedReason('');
            setChangePersonalEmail(personalEmail || '');
            setChangeRegisterEmail(registedEmail || '');
            setErrorMessage('');
            setEmailErrorMessage('')
        }
    }, [isEditUser, personalEmail, registedEmail]);

    useEffect(() => {
        if (profileData?.email) {
            setChangePersonalEmail(profileData?.email);
        }
        if (profileData?.registeredEmail) {
            setChangeRegisterEmail(profileData?.registeredEmail)
        }
    }, [profileData]);

    const handleSuspend = async (profileData) => {
        let data = null;
        setErrorMessage('');

        if (!changedReason?.trim()) {
            setErrorMessage("Please enter reason for suspension.");
            return;
        }
        if (profileData?.status === 1 || profileData?.status === 0) {
            data = await handleActionUser(changedReason, profileData)
        }
        if (profileData?.status === 3) {
            const data = await handleRestore(changedReason, profileData)
        }
        if (data) {
            setChangedReason('')
        }
    }

    const handleSave = async () => {
        if (!changedPersonalEmail?.trim()) {
            setEmailErrorMessage('Please fill personal email address.');
        }
        if (!changedRegisterEmail?.trim()) {
            setRegisterEmailErrorMessage('Please fill registered email address.');
        }
        setIsSaveLoading(true);
        if (changedPersonalEmail?.trim() === profileData?.email?.trim() && changedRegisterEmail?.trim() === profileData?.registeredEmail?.trim()) {
            setTimeout(() => {
                setIsSaveLoading(false);
                setEdit(false);
            }, 500);
            setShowNotification(true);
            setNotificationMessage('Your changes have been successfully saved.');
            setTimeout(() => {
                setShowNotification(false);
            }, 8000);
            return;
        }
        await handleUpdateUser(changedPersonalEmail, changedRegisterEmail);

    }

    return (

        <div className='founder-edit-section'>
            <div className='founder-details'>
                <div className='founder-dummy-image'>
                    <LazyImage
                        src={profileData?.profileImg}
                        alt="founder"
                    />
                </div>
                <div className='founder-detail-section'>
                    <div>
                        <span className='label'>Full name</span>
                        <div className='value'>{profileData?.name}</div>
                    </div>
                    {profileData?.type === 1 ? (
                        <>
                            <div>
                                <span className="label">Option</span>
                                <div className="value">
                                    {profileData?.university?.map((key, idx) => {
                                        const matched = university?.find(item => item?.key === key);
                                        return (
                                            <span key={key}>
                                                {matched?.value || key}
                                                {idx < profileData.university.length - 1 ? ', ' : ''}
                                            </span>
                                        );
                                    })}
                                </div>
                            </div>

                            <div>
                                <span className="label">Role in startup</span>
                                <div className="value">
                                    {
                                        staticData?.startupRole?.find(item => item.key === profileData?.role)?.value
                                        || profileData?.role
                                    }
                                </div>
                            </div>

                            <div>
                                <span className="label">LinkedIn profile</span>
                                <div className="value">{profileData?.linkedInUrl}</div>
                            </div>

                            <div>
                                <span className="label">Short bio</span>
                                <div className="value">{profileData?.about}</div>
                            </div>
                        </>
                    ) : profileData?.type === 2 ? (
                        <>
                            <div>
                                <span className="label">Job title</span>
                                <div className="value">{profileData?.jobTitle}</div>
                            </div>

                            <div>
                                <span className="label">LinkedIn profile</span>
                                <div className="value">{profileData?.linkedInUrl}</div>
                            </div>

                            <div>
                                <span className="label">Short bio</span>
                                <div className="value">{profileData?.about}</div>
                            </div>

                            <div>
                                <span className="label">Startups invested in</span>
                                <div className="value">{profileData?.investedIn}</div>
                            </div>

                            <div>
                                <span className="label">Easy scheduling URL</span>
                                <div className="value">{profileData?.scheduleUrl}</div>
                            </div>

                            <div>
                                <span className="label">Industries</span>
                                <div className="value">
                                    {profileData?.industryTags?.map((key, idx) => {
                                        const matched = industryTags?.find(item => item?.key === key);
                                        return (
                                            <span key={key}>
                                                {matched?.value || key}
                                                {idx < profileData.industryTags.length - 1 ? ', ' : ''}
                                            </span>
                                        );
                                    })}
                                </div>
                            </div>

                            <div>
                                <span className="label">Startup stages</span>
                                <div className="value">
                                    {profileData?.startupStages?.map((key, idx) => {
                                        const matched = startupStages?.find(item => item?.key === key);
                                        return (
                                            <span key={key}>
                                                {matched?.value || key}
                                                {idx < profileData.startupStages.length - 1 ? ', ' : ''}
                                            </span>
                                        );
                                    })}
                                </div>
                            </div>
                        </>
                    ) : profileData?.type === 3 || profileData?.type === 4 ? (
                        <>
                            <div>
                                <span className='label'>Job title</span>
                                <div className='value'>{profileData?.jobTitle}</div>
                            </div>
                            <div>
                                <span className='label'>LinkedIn profile</span>
                                <div className='value'>{profileData?.linkedInUrl}</div>
                            </div>
                            <div>
                                <span className='label'>Short bio</span>
                                <div className='value'>{profileData?.about}</div>
                            </div>
                            <div>
                                <span className='label'>Startups invested in</span>
                                <div className='value'>{profileData?.investedIn}</div>
                            </div>
                            <div>
                                <span className='label'>Easy scheduling URL</span>
                                <div className='value'>{profileData?.scheduleUrl}</div>
                            </div>
                        </>
                    ) : null}
                </div>

                <div className='divider'></div>
                <div className='email-section'>
                    <div className={`input-group ${changedPersonalEmail ? 'filled' : ''} ${emailErrorMessage && 'show-error'}`}>
                        <input type="email" id='email' name='email' autoComplete="off" value={changedPersonalEmail} onChange={(e) => {
                            setChangePersonalEmail(e.target.value);
                            if (emailErrorMessage) setEmailErrorMessage('');
                        }} />
                        <label htmlFor="email">Personal email address</label>
                    </div>
                    {emailErrorMessage && <p className="error-message">{emailErrorMessage}</p>}

                    {
                        profileData?.type === 1 &&
                        <>
                            <div className={`input-group ${changedRegisterEmail ? 'filled' : ''}${registerEmailErrorMessage && 'show-error'}`}>
                                <input type="email" id='registedEmail' name='registedEmail' autoComplete="off" value={changedRegisterEmail} onChange={(e) => {
                                    setChangeRegisterEmail(e.target.value)
                                    if (registerEmailErrorMessage) setRegisterEmailErrorMessage('');
                                }} />
                                <label htmlFor="registedEmail">Registration email address</label>
                            </div>
                            {registerEmailErrorMessage && <p className="error-message">{registerEmailErrorMessage}</p>}
                        </>
                    }
                </div>

                <div className='divider'></div>

                {(profileData?.status === 1 || profileData?.status === 0) &&
                    <div className='founder-suspend-section'>
                        <div className='title'>Suspend {profileData?.name}</div>
                        <div className='description'>
                            Suspending {profileData?.name} means they will be permanently suspended from using Ivycorn.
                        </div>
                        <div className={`input-group ${changedReason ? 'filled' : ''} ${errorMessage && 'show-error'}`}>
                            <input type="text" id='reason' name='reason' autoComplete="off" value={changedReason} onChange={(e) => {
                                setChangedReason(e.target.value);
                                if (errorMessage) setErrorMessage('');
                            }} />
                            <label htmlFor="reason">Reason to suspension</label>
                        </div>
                        {errorMessage && <p className="error-message">{errorMessage}</p>}
                        <button
                            className={`suspend-button button ${isSuspendLoading ? 'btn_loading' : ''
                                }`}
                            onClick={() => handleSuspend(profileData)}
                        >
                            {isSuspendLoading ? (
                                <div className="registerLoader">
                                    <div className="ring-loader"></div>
                                </div>
                            ) : (
                                'Suspend'
                            )}
                        </button>
                    </div>
                }

                {profileData?.status === 3 &&
                    <div className='founder-suspend-section'>
                        <div className='title'>Restore {profileData?.name}</div>
                        <div className='description'>
                            Restoring {profileData?.name} will reinstate their access to Ivycorn, allowing them to continue using the service.
                        </div>
                        <div className={`input-group ${changedReason ? 'filled' : ''} ${errorMessage && 'show-error'}`}>
                            <input type="text" id='reason' name='reason' autoComplete="off" value={changedReason} onChange={(e) => {
                                setChangedReason(e.target.value);
                                if (errorMessage) setErrorMessage('');
                            }} />
                            <label htmlFor="reason">Reason to restore</label>
                        </div>
                        {errorMessage && <p className="error-message">{errorMessage}</p>}
                        <button
                            className={`suspend-button button ${isSuspendLoading ? 'btn_loading' : ''
                                }`}
                            onClick={() => handleSuspend(profileData)}
                        >
                            {isSuspendLoading ? (
                                <div className="registerLoader">
                                    <div className="ring-loader"></div>
                                </div>
                            ) : (
                                'Restore'
                            )}
                        </button>
                    </div>
                }

                <div className='divider full'></div>
                <div className='save-button-group'>
                    <div className='cancel-button' onClick={() => { setEdit(false); setSelectUser({}); setEmailErrorMessage(''); setRegisterEmailErrorMessage('') }}>Cancel</div>
                    <button
                        className={`save-button button ${isSaveLoading ? 'btn_loading' : ''
                            }`}
                        onClick={() => { handleSave(); }}
                    >
                        {isSaveLoading ? (
                            <div className="registerLoader">
                                <div className="ring-loader"></div>
                            </div>
                        ) : (
                            'Save'
                        )}
                    </button>
                </div>
            </div>
        </div >
    )
}

export default ProfileTab